import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderSix, HeaderTwo } from 'secondstep-components'

export const ModalHeader = styled(HeaderTwo)`
  margin-bottom: 0.625rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};
`

export const ModalSubHeader = styled(HeaderSix)`
  font-family: ${themeGet('font.molde.regular')};
  color: ${themeGet('colors.darkGray')};
`
